// 首頁活動 loading 元件

const IndexEventSkeltonComponent = () => {
  return (
    <div className="rounded-[4px] w-[337px] h-[396px] ulg:h-[246px] skelton" />
  );
};

export default IndexEventSkeltonComponent;
